import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const BugIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="7.75" y="8" width="8.5" height="11.5" rx="4.25" />
            <path d="M9.6 8a2.4 2.4 0 0 1 4.8 0" />
            <path d="M12 11.5v7.5" />
            <path d="M7.75 13H4.75M16.25 13h3M8.3 16.6 5.6 18.2M15.7 16.6l2.7 1.6M8.3 10 5.9 8.4M15.7 10l2.4-1.6" />
        </g>
    </svg>
)

const BugIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {BugIconSvg}
    </SvgIcon>
)

export default BugIcon
